;(function ($) {

  $(function () {
    $('select').niceSelect();
  });

}(jQuery));
